import type { AxiosInstance } from 'axios';
import type { components, paths } from '../schema';
import type { RequestOptions } from './types';
import { curry1 } from './utils';

type User = {
  account_type: components['schemas']['EmployeeAccountTypeEnum'];
  display_name: string;
  email: string;
  first_name: string;
  id: string;
  last_name: string;
  picture_url: string | null;
};

export type Comment = {
  created: string;
  created_by: User;
  id: string;
  mentions: User[];
  text: string;
  updated: string;
};

type CreateCommentBody =
  paths['/api/comment']['post']['requestBody']['content']['application/json'];

interface CreateCommentResponse extends Comment {
  comments: Comment[];
}

export const createComment = async (
  instance: AxiosInstance,
  body: CreateCommentBody,
  options: RequestOptions = {}
): Promise<CreateCommentResponse> => {
  const res = await instance.post('/comment', body, options);

  return res.data;
};

export class CommentService {
  public createComment;

  constructor(private instance: AxiosInstance) {
    this.createComment = curry1(createComment)(this.instance);
  }
}
